import styled from 'styled-components';
import { MapMTK as PandoraMTKMap } from '@iib/pandora-box';

export const MapWrapper = styled.div`
  margin: auto;
  min-width: 280px;
  width: 100%;
  height: 100cqh;
  min-width: inherit;

  container-type: inline-size; // fixes width overflow issue of Map
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MapMTK = styled(PandoraMTKMap)`
  & > .screenshot-button {
    background-color: ${({ theme }) => theme.PRIMARY.MAIN};
    border: none;
  }
`;
